import { render, staticRenderFns } from "./QuickAccessTray.vue?vue&type=template&id=e9d1acd4&scoped=true"
import script from "./QuickAccessTray.vue?vue&type=script&lang=js"
export * from "./QuickAccessTray.vue?vue&type=script&lang=js"
import style0 from "./QuickAccessTray.vue?vue&type=style&index=0&id=e9d1acd4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9d1acd4",
  null
  
)

export default component.exports